import urls from '../constants/urls.js';
import BaseService from './baseService';

class ContactService {

    static sendContact(email, name, subject, message, username) {
        return BaseService.postAndReturn('/Contact', { email, name, subject, message, username }, BaseService.returnAssignedObject, null, true);
    }  

    static reportSpam(roleID, spamType, id) {
        return BaseService.postAndReturn('/ReportSpam', { roleID, spamType, id }, BaseService.returnAssignedObject, null, true);
    }
}
export default ContactService;